import { keyBy } from 'lodash-es';
import { Component, Input } from '@angular/core';
import { ClientReferralTask } from '../../../core/models/client-referral-task.model';
import { choiceOptions } from '../../../core/options/client-referral-task-choice-opts';
import { Capture } from '../../../core/models/capture.model';
import { ReferralVerificationReason } from 'app/core/enums/referral-verification-reason.enum';
import { CeReviewTaskContentComponent } from '../ce-review-task-content/ce-review-task-content.component';
import { DatePipe } from '@angular/common';
import { ClientReferralTaskOptionReasonComponent } from '../../../shared/components/client-referral-task-option-reason/client-referral-task-option-reason.component';

const KeyedChoiceOptions = keyBy(choiceOptions, 'value');

@Component({
    selector: 'app-ce-review-client-referral-task',
    templateUrl: './ce-review-client-referral-task.component.html',
    imports: [CeReviewTaskContentComponent, ClientReferralTaskOptionReasonComponent, DatePipe]
})
export class CeReviewClientReferralTaskComponent {
  keyedChoiceOptions = KeyedChoiceOptions;
  verificationReasons = ReferralVerificationReason;

  @Input() clientReferralTask: ClientReferralTask;
  @Input() capture: Capture;
}
